webpackJsonp([53224078107011],{

/***/ 1843:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LocationIntegrations","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"location","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"Location","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"message","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"Result of updating a location's integrations settings","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-location-integrations-01efa933f51d0294c36c.js